<template>
  <b-row align-h="center">
    <div class="w-75">
      <FITFormCard>
        <div slot="header">
          <b-row>
            <b-col cols="6">
              <h4>{{$t('home.customerPolicy.header')}}</h4>
            </b-col>
          </b-row>
        </div>
        <div slot="formBody">
          <div v-if="!isPolicyDetailEmpty">
            <h4 class="mb-3"><i class="fa fa-info-circle mr-2"></i>{{$t('osm.contents.giPolicy.generalInfo')}}</h4>
            <b-row>
              <b-col cols="6">
                <CustomerPolicyRow :title="$t(`${title}.policyNumber`)" :value="policyDetail.giGeneralInfo.policyNumber"></CustomerPolicyRow>
                <CustomerPolicyRow :title="$t(`${title}.productName`)" :value="productName"></CustomerPolicyRow>
                <CustomerPolicyRow :title="$t(`${title}.policyCurrency`)" :value="policyDetail.giGeneralInfo.policyCurrency"></CustomerPolicyRow>
                <CustomerPolicyRow :title="$t(`${title}.modalPremium`)" :value="'$ ' + policyDetail.giGeneralInfo.modalPremium"></CustomerPolicyRow>
                <CustomerPolicyRow v-if="this.detail.policyType === 'P'" :title="$t('osm.renewal.list.nextPaymentDate')" :value="policyDetail.giGeneralInfo.nextPaymentDate | date"></CustomerPolicyRow>
                <CustomerPolicyRow :title="$t(`${title}.serviceAgent`)" :value="serviceAgent"></CustomerPolicyRow>
              </b-col>
              <b-col>
                <CustomerPolicyRow :title="$t(`${title}.ownerCustomer`)" :value="ownerCustomer"></CustomerPolicyRow>
                <CustomerPolicyRow :title="$t(`${title}.insuredCustomer`)" :value="insuredCustomer"></CustomerPolicyRow>
                <CustomerPolicyRow :title="$t(`${title}.effectiveDate`)" :value="policyDetail.giGeneralInfo.effectiveDate | date"></CustomerPolicyRow>
                <CustomerPolicyRow :title="$t(`${title}.expiryDate`)" :value="policyDetail.giGeneralInfo.expiryDate | date"></CustomerPolicyRow>
                <CustomerPolicyRow :title="$t('home.customerPolicy.nextPaymentDate')" :value="policyDetail.giGeneralInfo.nextPaymentDate | date"></CustomerPolicyRow>
              </b-col>
            </b-row>
            <template v-if="this.detail.policyType === 'G' && policyDetail.giTypeInfo.length > 3" class="mt-3">
              <hr>
              <h5><i class="fa fa-file mr-2"></i>{{$t('osm.contents.giPolicy.policyInfo')}}</h5></b-col>
              <b-row>
                <b-col cols="6">
                  <template v-for="(value,key) in policyDetail.giTypeInfo">
                    <CustomerPolicyRow :title="$t(`osm.contents.giPolicy.productInformation.${key}`)" :value="getTranslatedPolicyTypeField(locale,allTypeInfoSelections,policyDetail.giGeneralInfo.policyType,key,value)"></CustomerPolicyRow>
                  </template>
                </b-col>
              </b-row>
            </template>
          </div>
          <b-progress v-else :value="100" variant="primary" :animated="true" class="mb-3"></b-progress>
        </div>
      </FITFormCard>
    </div>
  </b-row>
</template>
<script type="text/javascript">
import { FITFormCard, } from '@/components'
import { CustomerPolicyRow } from '../components'
import { mapGetters } from 'vuex'
import Vue from 'vue';
export default {
  name: 'CustomerPolicyDetail',
  props: {
    detail: {
      type: [Object],
      required: true
    }
  },
  created() {
    this.getSelectionsList();
    if (this.detail.ID) {
      this.getPolicyDetail();
    }
  },
  methods: {

    getPolicyDetail() {
      var params = { ID: this.detail.ID, policyType: this.detail.policyType }
      this.$store.dispatch('Homepage/getPolicyDetail', params).then((json) => {
        Vue.set(this, 'policyDetail', json.data);
        if (this.detail.policyType === 'G') {
          for (var i = 0; i < this.giUselessField.length; i++) {
            delete this.policyDetail.giTypeInfo[this.giUselessField[i]]
          }
        }
      }).catch((err) => {
        console.error(err);
      })
    },
    isEmptyName(eng, chi) {
      var name = ''
      if (eng) {
        name = eng
      }
      if (chi) {
        name = name + '<br>' + chi
      }
      return (name.length > 4) ? name : 'N/A'

    },
    getSelectionsList() {
      this.$store.dispatch('GIPolicy/getGITypeInfoSelections')
        .then((response) => {
          if (response.status != 200) {
            return;
          }
          Vue.set(this, 'allTypeInfoSelections', response.data);
          console.debug(response.data);
        }, (err) => {
          console.error(err);
        })
    },
  },
  data() {
    return {
      policyDetail: {},
      giUselessField: ['ID', 'version', 'generalPolicy'],
      allTypeInfoSelections: [],
    }
  },
  components: {
    CustomerPolicyRow,
    FITFormCard
  },
  computed: {
    ...mapGetters("GIPolicy", ['getTranslatedPolicyTypeField']),
    title() {
      return 'osm.contents.giPolicy.generalInformation'
    },
    isPolicyDetailEmpty() {
      return Object.keys(this.policyDetail).length === 0 && this.policyDetail.constructor === Object
    },
    productName() {
      return this.isEmptyName(this.policyDetail.giGeneralInfo.productEnglishName, this.policyDetail.giGeneralInfo.productChineseName);
    },
    ownerCustomer() {
      return this.isEmptyName(this.policyDetail.giGeneralInfo.englishNameOwnerCustomer, this.policyDetail.giGeneralInfo.chineseNameOwnerCustomer);
    },
    insuredCustomer() {
      return this.isEmptyName(this.policyDetail.giGeneralInfo.englishNameInsuredCustomer, this.policyDetail.giGeneralInfo.chineseNameInsuredCustomer);
    },
    locale() {
      return this.$i18n.locale;
    },
    serviceAgent() {
      return this.isEmptyName(this.policyDetail.giGeneralInfo.englishNameServiceAgent, this.policyDetail.giGeneralInfo.chineseNameServiceAgent);
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/Homepage/containers/CustomerPolicyDetail.vue